import { TemplateGalleryCard } from '@common/types';
import { TemplateGalleryCard as LibraryTemplateGalleryCard } from '@wix/wix-studio-marketplace-lib';
import {
  Industry,
  Style,
  SiteType,
} from '@wix/ambassador-partners-marketplace-v1-template-listing/types';
import { templatePath } from '@components/Hooks/useRouter';

export const INITIAL_TEMPLATES_LOAD_SIZE = 16;
export const TEMPLATES_DISPLAY_PAGE_SIZE = 8;
export const PROFILE_INITIAL_TEMPLATE_COUNT = 8;
export const TEMPLATES_DISPLAY_PAGE_SIZE_MOBILE = 4;
export const PROFILE_INITIAL_TEMPLATE_COUNT_MOBILE = 4;
export const MAX_TEMPLATES_COUNT_FOR_THREE_IN_ROW = 6;

export const mapTemplatesToLibraryFormat = (
  templates: TemplateGalleryCard[],
): LibraryTemplateGalleryCard[] => {
  return templates.map((template) => ({
    ...template,
    industries: template.industries?.map(
      (ind) => Industry[ind as keyof typeof Industry],
    ),
    styles: template.styles?.map((style) => Style[style as keyof typeof Style]),
    siteTypes: template.siteTypes?.map(
      (style) => SiteType[style as keyof typeof SiteType],
    ),
  }));
};

export const buildTemplatePageLink = (templateId?: string | null): string => {
  if (!templateId) return '';
  return `${templatePath}/${templateId}`;
};

export const scrollToTemplatesSection = (
  elementRef: React.RefObject<HTMLElement>,
  isMobileView: boolean,
): void => {
  if (elementRef.current) {
    const offset = isMobileView ? 130 : 120;
    const targetPosition =
      elementRef.current.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: targetPosition - offset,
      behavior: 'smooth',
    });
  }
};

export const formatAverageRating = (
  rating: number,
  language: string,
): string => {
  return Intl.NumberFormat(language, {
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
  }).format(rating);
};

export const calculateNextCount = (
  currentVisibleCount: number,
  totalAvailable: number,
  isMobileView: boolean = false,
): number => {
  const pageSize = isMobileView
    ? TEMPLATES_DISPLAY_PAGE_SIZE_MOBILE
    : TEMPLATES_DISPLAY_PAGE_SIZE;
  return Math.min(currentVisibleCount + pageSize, totalAvailable);
};

export const getNewTemplateSliceIndices = (
  galleryIndex: number,
  isMobileView: boolean = false,
) => {
  const initialCount = isMobileView
    ? PROFILE_INITIAL_TEMPLATE_COUNT_MOBILE
    : PROFILE_INITIAL_TEMPLATE_COUNT;
  const pageSize = isMobileView
    ? TEMPLATES_DISPLAY_PAGE_SIZE_MOBILE
    : TEMPLATES_DISPLAY_PAGE_SIZE;
  const startIndex = initialCount + galleryIndex * pageSize;
  const endIndex = startIndex + pageSize;
  return { startIndex, endIndex };
};
